import { cn } from '@/utils/cn';
import type { ComponentProps } from 'react';

type CodeBlockContainerProps = ComponentProps<'div'> & {
  language: string;
};

export const CodeBlockContainer = ({
  className,
  language,
  style,
  ...props
}: CodeBlockContainerProps) => (
  <div
    className={cn(
      'my-4 w-full overflow-hidden rounded-xl border border-border',
      'glass-card-without-shadow',
      className
    )}
    data-language={language}
    data-streamdown="code-block"
    style={{
      // Use content-visibility to skip rendering off-screen blocks
      // This can significantly improve performance for large documents
      contentVisibility: 'auto',
      // Provide a hint for layout to prevent layout shifts
      containIntrinsicSize: 'auto 12.5rem',
      ...style,
    }}
    {...props}
  />
);
